import NewUom from "../../../../components/@products/uoms/NewUom";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function UomNewPage() {

    return (
        <NewUom 
            routeType={routeTypes.admin}
        />
    )
}       